import * as React from "react";
import IDropdownProps from "./IDropdown";
import { bindActionCreators } from "redux";
import "../../../assets/sass/widgets/unchainedDropDown.scss";
import DialogBox from "../DialogBox/index";
import Label from "../../components/Label";
import { connect } from "react-redux";
import * as dynamicFormActionCreators from "../../components/DynamicForm/actionCreators";
import { validationCheck } from "../../utils/validation";
import { valueResolver, getPriceCheckDetails, imagePathurl } from "../../utils/utils";
import * as globalErrorActionCreators from "../../globalStore/actions";
import { fetchAPI } from "../../utils/service";
import endpoints, { endpointTypes } from "../../service";
import { isInViewport, checkForReadOnly, checkForPriceChanges } from "../../utils/utils";
import * as CONFIG from "../../../config.json";
import constantFile from "../../constants/constantFile";

let hasOtherFieldsUpdated = false;
let defaultProjectInfo = {};

enum KEYPRESS {
    DOWN = "ArrowDown",
    UP = "ArrowUp",
    ESC = "Escape",
    ENTER = "Enter",
}

interface IDropdownStateProps {
    isDropDown?: any;
    dropDownValue?: any;
    isWarrantyTypeUpdated?: any;
    hasOtherFieldsUpdated?: any;
    isProjectDetailsPage?: any;
    dropDownNewValue?: any;
    dropDownOptions?: any;
    const?: any;
    isFormValidationSuccess?: any;
    error?: any;
    previousValue?: any;
    cursor?: any;
    count: any;
    searchIndexValue: string;
}

/**
 * @class UnchainedDropDownWidget
 * @category Widgets
 * @description renders the warranty selection dropdown
 */
class UnchainedDropDown extends React.Component<IDropdownProps, IDropdownStateProps> {
    private keyPressTimer: NodeJS.Timeout = null;

    private readonly unchainedDropDownRef: React.LegacyRef<HTMLUListElement>;
    constructor(props) {
        super(props);
        this.unchainedDropDownRef = React.createRef();
        this.state = {
            isDropDown: false,
            cursor: -1,
            count: 0,
            isWarrantyTypeUpdated: false,
            isProjectDetailsPage: true,
            dropDownValue: "",
            isFormValidationSuccess: false,
            error: { error: false, errorMessage: [] },
            previousValue: this.props.schema.anyOf.filter((item) => item.enum[0] === this.props.value)[0],
            searchIndexValue: "",
        };
        this.toggleDropDown = this.toggleDropDown.bind(this);
        this.hideDropDown = this.hideDropDown.bind(this);
        this.getTitleByKey = this.getTitleByKey.bind(this);
        this.onDropDownChange = this.onDropDownChange.bind(this);
        this.onWarrantyChange = this.onWarrantyChange.bind(this);
        this.isFormFilled = this.isFormFilled.bind(this);
        this.formValidation = this.formValidation.bind(this);
        this.updateChange = this.updateChange.bind(this);
        this.hidePopUp = this.hidePopUp.bind(this);
        this.blurCheck = this.blurCheck.bind(this);
    }

    toggleDropDown() {
        const { isDropDown, dropDownValue } = this.state;
        const { schema } = this.props;
        this.setState({ isDropDown: !isDropDown, cursor: -1 }, () => {
            if (dropDownValue !== "- Select -") {
                const { removeFieldIdFromStore } = this.props.dynamicFormActions;
                removeFieldIdFromStore(this.props.id);
            }
            if (dropDownValue) {
                const element: HTMLElement = document.getElementById(dropDownValue);
                if (element) {
                    const cursor = schema.anyOf.findIndex((option) => option.title === dropDownValue);
                    this.setState({ cursor, count: cursor * 40 });
                    element.parentElement.scrollTop = element.offsetTop;
                }
            }
            // if dropdown not completely show in viewport, scrollTo viewport
            if (this.state.isDropDown) {
                const current = this.unchainedDropDownRef["current"];
                if (!isInViewport(current)) {
                    current.scrollIntoView({
                        behavior: "auto",
                        block: "center",
                        inline: "center",
                    });
                }
            }
        });
    }

    hideDropDown() {
        this.setState({ isDropDown: false, count: 0, cursor: -1 }, () => {
            this.blurCheck(this.state.dropDownValue);
        });
        document.body.classList.remove("hideOverflow");
        document.getElementsByTagName("body")[0].style.overflow = "scroll";
    }

    /**
     * Once user stop type, search the relevant result and
     * selected from dropdown
     */
    chooseOptionBySearch = () => {
        const { schema } = this.props;
        const { searchIndexValue } = this.state;
        let { count, cursor } = this.state;
        if (searchIndexValue) {
            const matchOptionIndex = schema.anyOf.findIndex(
                (option) => option.title.toLowerCase().indexOf(this.state.searchIndexValue.toLowerCase()) === 0
            );
            const matchOption = schema.anyOf[matchOptionIndex];
            if (matchOption) {
                this.onDropDownChange(matchOption.title, matchOption.enum[0]);
                this.blurCheck(matchOption.title);
                const element: HTMLElement = document.getElementById(this.state.dropDownValue);
                if (element) {
                    element.parentElement.scrollTop = element.offsetTop;
                }
                cursor = matchOptionIndex;
                count = cursor * 40;
            }
        }
        this.setState({ searchIndexValue: "", cursor, count });
    };

    /**
     * Open DropDown And ScrollTo highlight element
     * @param {number} count
     * @param {number} cursor
     */
    openDropDownAndScrollTo = (count: number, cursor: number) => {
        this.setState({ isDropDown: true, count, cursor }, () => {
            document.getElementsByTagName("body")[0].style.overflow = "hidden";
            this.unchainedDropDownRef["current"].scrollTo(0, count);
        });
    };

    /**
     * Handle onKeyDown on dropdown list
     * store all the keydown value in component state until user stop typing
     * @param {KeyboardEvent} event
     */
    showDropDown = (event: any) => {
        let { count } = this.state;
        const { cursor, isDropDown } = this.state;
        const { schema } = this.props;
        const { key } = event;

        const dropDownOptionsLength = schema.anyOf.length;
        const downArrowKeyValue = dropDownOptionsLength * 40;

        if (Object.values(KEYPRESS).includes(key)) {
            if (key === KEYPRESS.ESC) {
                return this.hideDropDown();
            }
            if (key === KEYPRESS.DOWN) {
                if (!isDropDown) {
                    this.toggleDropDown();
                } else {
                    count = count + 40;
                    if (count <= downArrowKeyValue) {
                        this.openDropDownAndScrollTo(count, cursor + 1);
                    }
                }
            }
            if (key === KEYPRESS.UP) {
                if (isDropDown) {
                    count = count - 40;
                    if (count >= 0) {
                        this.openDropDownAndScrollTo(count, cursor - 1);
                    }
                }
            }
            if (key === KEYPRESS.ENTER && cursor !== -1) {
                const selectedOption = schema.anyOf[cursor];
                this.onDropDownChange(selectedOption.title, selectedOption.enum[0]);
                this.blurCheck(selectedOption.title);
                this.hideDropDown();
            }
        } else {
            clearTimeout(this.keyPressTimer);
            this.setState({ searchIndexValue: `${this.state.searchIndexValue}${key}` });
            this.keyPressTimer = setTimeout(this.chooseOptionBySearch, 500);
        }
    };

    /**
     * This is for drop down changes
     * @param value
     * @param dropDownOption
     */
    onDropDownChange(value, dropDownOption) {
        // checking if the form is filled or pratially filled
        if (value !== this.state.dropDownValue) {
            this.isFormFilled();
            // Based on the value that we receive from isFormFilled function
            // we validate and call on onWarrantyChange or else just set the sate.
            if (hasOtherFieldsUpdated && this.state.isProjectDetailsPage) {
                this.onWarrantyChange(value, dropDownOption, this.state.dropDownValue);
            } else {
                this.setState({ dropDownValue: value }, () => {
                    this.props.onChange(dropDownOption);
                });
            }
        }
    }

    componentDidMount() {
        const { value, schema } = this.props;
        let title = "- Select -";
        let key = undefined;
        // if previous value is provided, update the dropdown
        if ((typeof value === "string" || typeof value === "number") && value) {
            title = this.getTitleByKey(value);
            key = value;
            // if there is no previous value & default value is provided, update the dropdown
        } else if (schema.default) {
            title = this.getTitleByKey(schema.default);
            key = schema.default;
        }
        this.setState({ dropDownValue: title }, () => {
            this.props.onChange(key);
        });
    }

    componentDidUpdate(nextProps: any, nextState: any) {
        if (nextProps.value !== this.props.value) {
            this.props.onChange(this.props.value);
            // clear the copy of formdata after the default value is set on every dropdown change
            defaultProjectInfo = {};
        }
    }

    checkForPrice = (e) => {
        const { errorSchema, schema, id } = this.props;
        const { fieldName, priceCheck } = getPriceCheckDetails(errorSchema, schema, id);
        let reqObject;
        for (const i in JSON.parse(priceCheck[0].value)) {
            reqObject = {
                ...reqObject,
                [i]: valueResolver(this.props.warrantyData, JSON.parse(priceCheck[0].value)[i].trim()),
                [fieldName]: e,
            };
        }
        const requestobject = {
            data: reqObject,
            warrantyId: this.props.warrantyId,
        };
        reqObject.api = priceCheck[0].api;
        const successCallBackEditCheck = async () => {
            const formLayoutRoute = endpoints[endpointTypes.FORMLAYOUT];
            const editableCheckEndpoint = formLayoutRoute.endpoints.checkEditable(requestobject);
            try {
                const response = await fetchAPI(editableCheckEndpoint);
                return response;
            } catch (err) {
                this.setState({
                    dropDownValue: this.state.previousValue,
                    error: { error: true, errorMessage: [priceCheck[0].message] },
                });
                this.props.globalErrorActions.showGlobalError(err);
            }
        };
        return successCallBackEditCheck();
    };

    /**
     *
     * @param key get the title from the key
     */
    getTitleByKey(key) {
        const obj = this.props.schema.anyOf.filter((item) => item.enum["0"] === key);
        return obj[0] && obj[0].title;
    }

    /**
     * This is to validate in the project details Page if the form is filled and is
     * Warrenty change event is triggered.
     * @param value
     * @param dropDownOption
     */
    onWarrantyChange(value, dropDownOption, prevValue) {
        // Validating the form it should go to utils as of now
        // not functional as of now dummy
        this.formValidation();
        //setting the state of dropdown and isWarrantyType

        const status = prevValue !== "- Select -";
        if (status) {
            this.setState({
                dropDownNewValue: value,
                dropDownOptions: dropDownOption,
                isWarrantyTypeUpdated: status,
            });
        } else {
            this.setState(
                {
                    dropDownValue: value,
                    dropDownOptions: dropDownOption,
                    isWarrantyTypeUpdated: status,
                },
                () => {
                    this.props.onChange(dropDownOption);
                }
            );
        }
        document.body.classList.add("hideOverflow");
    }
    /**
     * This will be triggered when you fill the form
     * and try to change the warraenty type
     * @param value
     * @param dropDownOption
     */
    async updateChange(value, dropDownOption) {
        const { errorSchema, schema, id } = this.props;
        const { isSubmittedForm } = schema.const;
        const { priceCheck } = getPriceCheckDetails(errorSchema, schema, id);
        // const id = this.props.id.split("_");
        // const fieldName = this.props.id.split("_")[id.length - 1];
        // const dataValidatorPath =
        //     errorSchema &&
        //     errorSchema.length &&
        //     errorSchema.filter((key) =>
        //         key.parentDependency ? key.key === fieldName && key.parentDependency === family : key.key === fieldName
        //     );
        // const priceCheck = dataValidatorPath[0].value.filter((val) => val.validationType === "priceCheck");

        if (priceCheck && priceCheck.length > 0 && checkForPriceChanges(schema.const, isSubmittedForm)) {
            const x = await this.checkForPrice(value);
            if (x && x.data && x.data.isPriceChanged) {
                this.setState(
                    {
                        dropDownValue: this.state.previousValue.title,
                        dropDownOptions: this.state.previousValue.enum[0],
                        isWarrantyTypeUpdated: false,
                        error: { error: true, errorMessage: [priceCheck[0].message] },
                    },
                    () => {
                        this.props.onChange(this.state.previousValue.enum[0]);
                    }
                );
            }
        } else {
            this.setState(
                {
                    dropDownValue: value,
                    dropDownOptions: dropDownOption,
                    isWarrantyTypeUpdated: false,
                },
                () => {
                    this.props.onChange(dropDownOption);
                }
            );
        }
    }

    /**
     * This is to hide the popUp
     */
    hidePopUp() {
        this.setState({ isWarrantyTypeUpdated: false });
    }

    /**
     * Check the form data and see if we have any form filled
     * in Project details page
     */
    isFormFilled() {
        const { formData } = this.props;
        const projFormData = formData.residentialWarrantyForm.projectDetails;
        const projectDetailsDepFields = projFormData && Object.values(projFormData);
        //let projectDetailsDepFields = Object;
        if (
            projectDetailsDepFields &&
            projectDetailsDepFields.length > 1 &&
            JSON.stringify(projFormData) !== JSON.stringify(defaultProjectInfo)
        ) {
            hasOtherFieldsUpdated = true;
            this.setState({ isProjectDetailsPage: true });
        } else {
            hasOtherFieldsUpdated = false;
        }
    }

    /**
     * This is an abstract call for validation and
     * and which can be used for from validation
     * Should be calling a common validation platform.
     */
    formValidation() {
        // const { formData } = this.props;
        this.setState({ isFormValidationSuccess: true });
    }

    blurCheck(value) {
        const { errorSchema, schema, id, warrantyData } = this.props;
        // using validate_warrantyTypes variable to check the validation for President's Club warranty
        const validate_warrantyTypes = constantFile.validate_warrantyTypes;
        // const warrantyFixCheckValue = "President's Club";
        // const { family } = this.props.schema.const;
        // const id = this.props.id.split("_");
        // const fieldName = this.props.id.split("_")[id.length - 1];
        const currentStructureType = warrantyData?.residentialWarrantyForm?.buildingAndOwnerInfo?.structureType;
        const { family, fieldName } = getPriceCheckDetails(errorSchema, schema, id);
        if (value === "- Select -") {
            this.setState({
                error: validationCheck("", fieldName, family, errorSchema),
            });
        } else {
            // Checking for the structure type is SF & the warranty type is President's Club then keep the validation message else remove it on selection of value in warranty type drop down.
            if (currentStructureType != 'SF' && value == validate_warrantyTypes) {
                this.setState(
                    {
                        error: validationCheck(value, fieldName, family, errorSchema),
                    }
                );
            }
            else {
                this.setState(
                    {
                        error: validationCheck(value, fieldName, family, errorSchema),
                    },
                    () => {
                        const { removeFieldIdFromStore } = this.props.dynamicFormActions;
                        removeFieldIdFromStore(this.props.id);
                    }
                );
            }

        }
    }

    /**
     * Render method
     */
    render() {
        //image CDN_PATH
        const getimagePath = imagePathurl();
        const { schema, id, isSubmittedForm, contractorSettings } = this.props;
        const { isDropDown, cursor } = this.state;
        const PDMenu = this.props.menuKeys.filter((item) => Object.keys(item).indexOf("PD") >= 0);
        // keep the copy of formdata after the default value is set inorder to validate any change is made in the form
        if (
            this.props.formData.residentialWarrantyForm.projectDetails &&
            Object.keys(this.props.formData.residentialWarrantyForm.projectDetails).length > 1 &&
            Object.keys(defaultProjectInfo).length === 0
        ) {
            defaultProjectInfo = this.props.formData.residentialWarrantyForm.projectDetails;
        }
        const warrantyList =
            contractorSettings.warrantyTypes && contractorSettings.warrantyTypes.length > 0
                ? schema.anyOf.filter((x) => contractorSettings.warrantyTypes.includes(x.enum[0]))
                : schema.anyOf;
        return (
            <div>
                <Label schema={schema} />
                {this.state.isWarrantyTypeUpdated ? (
                    <DialogBox
                        buttonClass={this.props.schema.const.popup.buttonClass}
                        popupMessage={this.props.schema.const.popup.popupMessage}
                        warningMessage={this.props.schema.const.popup.warningMessage}
                        buttonText={this.props.schema.const.popup.buttonText}
                        options=""
                        currentOption={this.state.dropDownOptions}
                        value={this.state.dropDownNewValue}
                        updateChange={this.updateChange}
                        isFormValidationSuccess={this.state.isFormValidationSuccess}
                        hidePopsUp={this.hidePopUp}
                        tabIndex={this.props.schema.const.tabIndex}
                    />
                ) : (
                    ""
                )}
                <div
                    id={id}
                    className={
                        (this.state.error && this.state.error.error && this.state.error.errorMessage.length > 0) ||
                            ((PDMenu[0].visitCount > 1 || this.props.isDraft) &&
                                this.props.errorDetails[id] &&
                                this.props.errorDetails[id].length > 0)
                            ? "error-boundry gaf-dropdown"
                            : "gaf-dropdown"
                    }
                    onClick={checkForReadOnly(schema.const, isSubmittedForm) ? () => { } : this.toggleDropDown}
                    onBlur={checkForReadOnly(schema.const, isSubmittedForm) ? () => { } : this.hideDropDown}
                    tabIndex={schema.const.tabIndex || 0}
                    onKeyDown={checkForReadOnly(schema.const, isSubmittedForm) ? () => { } : this.showDropDown}
                >
                    <img src={`${getimagePath}chevron-down.png`} className="chevron-down-thickred" />
                    <p className="dropdown-selection"> {this.state.dropDownValue} </p>
                    {isDropDown && (
                        <ul className="dropdown-list" ref={this.unchainedDropDownRef}>
                            <li
                                key="select"
                                onClick={(e) => {
                                    this.onDropDownChange("- Select -", "");
                                    this.blurCheck("- Select -");
                                }}
                            >
                                - Select -
                            </li>
                            {warrantyList.map((option, index) => {
                                return (
                                    <li
                                        key={index}
                                        id={option.title}
                                        className={cursor === index ? "keyBoardAccess" : null}
                                        onClick={() => {
                                            this.onDropDownChange(option.title, option.enum[0]);
                                            this.blurCheck(option.title);
                                        }}
                                    >
                                        {option.title}
                                    </li>
                                );
                            })}
                        </ul>
                    )}
                </div>
                {this.state.error && this.state.error.error && this.state.error.errorMessage.length > 0 && (
                    <div className="error-message">
                        {this.state.error.errorMessage.map((msg, id) => (
                            <p key={id}>
                                <img className="ccz-img" src={`${getimagePath}error-field-icon.png`} alt="error" />
                                &nbsp;
                                {msg}
                            </p>
                        ))}
                    </div>
                )}
                {this.state.error && !this.state.error.error &&
                    (PDMenu[0].visitCount > 1 || this.props.isDraft) &&
                    this.props.errorDetails[id] &&
                    this.props.errorDetails[id].length > 0 && (
                        <div className="error-message">
                            {this.props.errorDetails[id].map((msg, id) => (
                                <p key={id}>
                                    <img className="ccz-img" src={`${getimagePath}error-field-icon.png`} alt="error" />
                                    &nbsp;
                                    {msg}
                                </p>
                            ))}
                        </div>
                    )}
            </div>
        );
    }
}

export function mapStateToProps(state) {
    return {
        formId: state.dynamicFormInfo.formId,
        warrantyId: state.dynamicFormInfo.warrantyId,
        warrantyData: state.dynamicFormInfo.layoutResponse.WarrantyData,
        formData: state.dynamicFormInfo.warrantyInfo,
        saveMsg: state.dynamicFormInfo.saveMsg,
        errorDetails: state.dynamicFormInfo.errorDetails || {},
        menuKeys: state.dynamicFormInfo.menuKeys,
        isDraft: state.dynamicFormInfo.isDraft,
        isSubmittedForm: state.adminData.isSubmittedForm,
        contractorSettings: state.dynamicFormInfo.contractorSettings || {},
    };
}

export function mapDispatchToProps(dispatch) {
    return {
        dynamicFormActions: bindActionCreators(dynamicFormActionCreators, dispatch),
        globalErrorActions: bindActionCreators(globalErrorActionCreators, dispatch),
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(UnchainedDropDown);
